export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "updates",
      layout: "dashboard",
    },
    path: "/updates",
    name: "updates",
    component: () => import("@/layouts/index/UpdateIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de clients",
          layout: "dashboard",
        },
        path: "index",
        name: "updates-index",
        component: () => import("@/views/updates/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un compte clientèle",
          layout: "dashboard",
        },
        path: "create",
        name: "updates-create",
        component: () => import("@/views/updates/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de vente",
          layout: "dashboard",
        },
        path: "sales/:reference/details",
        name: "sales-updates-details",
        component: () => import("@/views/updates/SaleDetails.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de commande",
          layout: "dashboard",
        },
        path: "orders/:reference/details",
        name: "orders-updates-details",
        component: () => import("@/views/updates/OrderDetails.vue"),
      },
    ],
  },
];
